<template>
  <div class="log">
    <button
      v-permissions="'view-details-jobs'"
      @click.stop="dialog = false"
      @click="getResponse"
      title="bids"
      target="_blank"
      class="view-ass-btn tender-action-btn tender-action-btn--bids"
    >
      Bids
    </button>

    <v-dialog
      v-model="dialog"
      max-width="72rem"
      persistent
      content-class="tender-bid-response-dialog"
    >
      <v-form ref="form" onsubmit="return false;">
        <v-card class="comments-view tender-bid-response-card">
          <header class="tender-bid-response-header">
            <div class="tender-bid-response-header__brand">
              <div class="tender-bid-response-header__badge" aria-hidden="true">
                <v-icon>gavel</v-icon>
              </div>
              <div class="tender-bid-response-header__copy">
                <h2 class="tender-bid-response-title">View Bid Response</h2>
                <p class="tender-bid-response-subtitle">
                  Job Id {{ bid.jobId || "—" }}
                </p>
              </div>
            </div>
            <v-btn
              icon
              class="tender-bid-response-close"
              @click.prevent="dialog = false"
              title="Close"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </header>

          <v-progress-linear
            indeterminate
            color="trukkin-theme darken-2"
            v-show="loading"
          ></v-progress-linear>

          <v-card-text class="tender-bid-response-body">
            <div class="tender-bid-response-meta">
              <div class="tender-bid-response-meta__item">
                <span class="tender-bid-response-meta__label">Job Id</span>
                <strong class="tender-bid-response-meta__value">
                  {{ bid.jobId || "—" }}
                </strong>
              </div>
              <div class="tender-bid-response-meta__item">
                <span class="tender-bid-response-meta__label">Comments</span>
                <strong class="tender-bid-response-meta__value">
                  {{ bid.commentForBid || "—" }}
                </strong>
              </div>
              <div
                class="tender-bid-response-meta__item tender-bid-response-meta__item--timer"
              >
                <span class="tender-bid-response-meta__label">Expires in</span>
                <div class="tender-bid-response-timer">
                  <vue-countdown-timer
                    @start_callback="startCallBack('event started')"
                    @end_callback="endCallBack('event ended')"
                    :start-time="currentDate"
                    :end-time="bid.closedDate"
                    :interval="1000"
                    :start-label="''"
                    :end-label="''"
                    label-position="begin"
                    :end-text="'Bid is closed'"
                    :day-txt="'day'"
                    :hour-txt="':'"
                    :minutes-txt="':'"
                    :seconds-txt="''"
                  >
                    <template slot="countdown" slot-scope="scope">
                      <span class="tender-bid-response-timer__part">
                        <strong>{{ scope.props.days }}</strong>
                        <small>{{
                          scope.props.days === 1 ? "day" : "days"
                        }}</small>
                      </span>
                      <span class="tender-bid-response-timer__clock">
                        <strong>{{ padTime(scope.props.hours) }}</strong>
                        <i>:</i>
                        <strong>{{ padTime(scope.props.minutes) }}</strong>
                        <i>:</i>
                        <strong>{{ padTime(scope.props.seconds) }}</strong>
                        <small>HH:MM:SS</small>
                      </span>
                    </template>
                  </vue-countdown-timer>
                </div>
              </div>
            </div>

            <div class="tender-bid-response-table-wrap">
              <v-data-table
                id="jobsTable"
                class="tender-bid-response-table"
                hide-actions
                :headers="headers"
                :items="items.list"
                no-data-text="No data available"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    {{ props.item.transporter[0].transporterName }} ({{
                      props.item.transporter[0].transporterId
                    }})
                    <br />
                    {{ props.item.transporter[0].email }}
                    <br />
                    {{ props.item.transporter[0].countryCode }}-{{
                      props.item.transporter[0].phoneNo
                    }}
                  </td>
                  <td>{{ getTime(props.item.updatedAt) }}</td>
                  <td>
                    {{ $formatPrice(props.item.amount) }}
                    {{ transporterCurrency }}
                  </td>
                  <td>{{ props.item.providedTrucks }}</td>
                  <td>
                    {{
                      $formatPrice(
                        props.item.amount / props.item.providedTrucks
                      )
                    }}
                    {{ transporterCurrency }}
                  </td>
                  <td>
                    <v-tooltip bottom v-if="props.item.comments">
                      <template v-slot:activator="{ on }">
                        <span class="fix-width-td" v-on="on">{{
                          props.item.comments
                        }}</span>
                      </template>
                      <span>{{ props.item.comments }}</span>
                    </v-tooltip>
                    <span v-if="!props.item.comments">-</span>
                  </td>
                  <td>
                    <span
                      class="tender-bid-status tender-bid-status--pending"
                      v-if="showAccept && !props.item.isApproved"
                      >Pending</span
                    >
                    <span
                      class="tender-bid-status tender-bid-status--rejected"
                      v-if="!showAccept && !props.item.isApproved"
                      >Rejected</span
                    >
                    <span
                      class="tender-bid-status tender-bid-status--accepted"
                      v-if="
                        props.item.isApproved || props.item.jobModel == 'Fixed'
                      "
                      >Accepted</span
                    >
                  </td>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar
      :timeout="3000"
      bottom
      color="red darken-2"
      v-model="error"
      class="white--text"
      v-if="error"
      >{{ error }}</v-snackbar
    >
  </div>
</template>
<script>
import Bidpopup from "@/components/Procurement/Bidpopup";
import ErrorBox from "@/components/Common/ErrorBox";
import ApprovalPopup from "@/components/Pop-ups/ApprovalPopup.vue";
import { tenderViewBidList } from "@/constants/datatable-headers.js";
import { sendBidpopupTransporterResponseList } from "@/constants/datatable-headers.js";
import { tenderSectionApiUrl } from "@/constants/api-urls.js";
import moment from "moment";
import { StorageKeys } from "../../constants/constants";

export default {
  name: "Timer",
  components: {
    Bidpopup,
    ErrorBox,
    ApprovalPopup,
  },
  computed: {
    haserror() {
      return this.x.error !== null;
    },
  },
  data() {
    return {
      currentDate: new Date().toLocaleString(),
      error: "",
      transporterCurrency: this.bid.transporterCurrency,
      totalTrucks: this.bid.assignCount,
      amount: this.bid.amount,
      JModel: this.bid.jobModel,
      showAccept: true,
      loading: false,
      x: {
        error: null,
      },
      is_accepted: false,
      items: [],
      processing: false,
      reason: "",
      dialog: false,
      disStatus: false,
      rules: {
        required: (value) => !!value || "This field is required.",
      },
      headers: sendBidpopupTransporterResponseList,
    };
  },
  props: {
    bid: Object,
  },
  created() {
    this.$emit("response-job", this.bid);
  },

  methods: {
    padTime(value) {
      const num = Number(value) || 0;
      return num < 10 ? `0${num}` : `${num}`;
    },
    refresh() {
      this.getResponse();
      this.$emit("refresh-tender-list");
    },
    getTime(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },

    startCallBack: function(x) {
      this.loading = false;
    },
    endCallBack: function(x) {
      this.loading = false;
    },
    getResponse() {
      if (!navigator.onLine) {
        this.loading = false;
        this.error = "Please check your internet connection";
        setTimeout(() => {
          this.error = "";
        }, 3000);
        return;
      }
      this.dialog = true;

      (this.loading = "true"), this.$emit("response-job", this.bid);

      this.dialog = true;
      this.processing = true;
      let url = tenderSectionApiUrl.viewBid;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        jobId: this.bid._id,
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.dialog = true;
          this.items = response.data.data;

          this.$emit("response-job", this.bid);

          this.processing = false;
          this.loading = false;
          let showAccept = true;
          let data = response.data.data.list.filter((ele) => {
            return ele.isApproved === true;
          });

          if (data.length) {
            this.showAccept = false;
          }
        },
        (error) => {
          this.error = "Failed to Fetch Assignments";
          this.processing = false;
          this.loading = false;
        }
      );
    },
  },
};
</script>

<style scoped>
.tender-bid-response-header {
  align-items: center;
  background:
    radial-gradient(circle at 100% 0%, rgba(245, 130, 32, 0.14), transparent 42%),
    linear-gradient(135deg, #fff7ed 0%, #ffffff 55%, #f4f7fb 100%);
  border-bottom: 0.0625rem solid #fed7aa;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 0.85rem 1rem;
}

.tender-bid-response-header__brand {
  align-items: center;
  display: flex;
  gap: 0.7rem;
  min-width: 0;
}

.tender-bid-response-header__badge {
  align-items: center;
  background: linear-gradient(160deg, #1c2b5f 0%, #2a3f7a 100%);
  border-radius: 0.7rem;
  box-shadow: 0 0.35rem 0.75rem rgba(28, 43, 95, 0.22);
  display: inline-flex;
  flex: 0 0 auto;
  height: 2.35rem;
  justify-content: center;
  position: relative;
  width: 2.35rem;
}

.tender-bid-response-header__badge::after {
  background: #f58220;
  border-radius: 999px;
  bottom: 0.26rem;
  content: "";
  height: 0.18rem;
  left: 0.48rem;
  position: absolute;
  right: 0.48rem;
}

.tender-bid-response-header__badge .v-icon {
  color: #ffffff !important;
  font-size: 1.05rem !important;
  margin-top: -0.1rem;
}

.tender-bid-response-header__copy {
  min-width: 0;
}

.tender-bid-response-title {
  color: #1c2b5f !important;
  font-size: 1rem !important;
  font-weight: 800 !important;
  letter-spacing: -0.01em;
  line-height: 1.2;
  margin: 0;
}

.tender-bid-response-subtitle {
  color: #c35f02;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  margin: 0.15rem 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tender-bid-response-close {
  color: #5b6475 !important;
}

.tender-bid-response-body.v-card__text {
  background: #ffffff;
  flex: 1 1 auto !important;
  max-height: min(72vh, 40rem);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 1rem 1.15rem 1.15rem !important;
}

.tender-bid-response-meta {
  display: grid;
  gap: 0.65rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-bottom: 0.95rem;
}

.tender-bid-response-meta__item {
  background: #fffaf4;
  border: 0.0625rem solid #fed7aa;
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
  padding: 0.7rem 0.85rem;
}

.tender-bid-response-meta__item--timer {
  grid-column: span 1;
}

.tender-bid-response-meta__label {
  color: #8a857c;
  font-size: 0.6875rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  line-height: 1.3;
  text-transform: uppercase;
}

.tender-bid-response-meta__value {
  color: #1a1916;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.tender-bid-response-timer {
  color: #1c2b5f;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.35;
}

.tender-bid-response-timer__part,
.tender-bid-response-timer__clock {
  align-items: baseline;
  display: inline-flex;
  gap: 0.2rem;
  margin-right: 0.45rem;
}

.tender-bid-response-timer small {
  color: #8a857c;
  font-size: 0.6875rem;
  font-style: normal;
  font-weight: 700;
  text-transform: uppercase;
}

.tender-bid-response-timer i {
  color: #c35f02;
  font-style: normal;
  font-weight: 800;
}

.tender-bid-response-table-wrap {
  background: #ffffff;
  border: 0.0625rem solid #e7ecf3;
  border-radius: 0.85rem;
  overflow: hidden;
}

.tender-bid-response-table ::v-deep table.v-table thead th,
.tender-bid-response-table ::v-deep table.v-table thead th.table-header-item {
  background: #fff7ed !important;
  border-bottom: 0.0625rem solid #fed7aa !important;
  color: #9a4f08 !important;
  font-size: 0.6875rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  -webkit-text-fill-color: #9a4f08 !important;
}

.tender-bid-response-table ::v-deep table.v-table thead th span,
.tender-bid-response-table ::v-deep table.v-table thead th .v-icon {
  color: #9a4f08 !important;
  -webkit-text-fill-color: #9a4f08 !important;
}

.tender-bid-response-table ::v-deep table.v-table tbody td {
  color: #2e3748;
  font-size: 0.8125rem !important;
  vertical-align: top;
}

.tender-bid-response-table ::v-deep table.v-table tbody td[colspan] {
  color: #64748b !important;
  font-weight: 700;
  height: 4.5rem;
  text-align: center !important;
}

.tender-bid-status {
  border-radius: 999px;
  display: inline-flex;
  font-size: 0.75rem !important;
  font-weight: 700;
  line-height: 1;
  padding: 0.35rem 0.6rem;
}

.tender-bid-status--pending {
  background: #eef2f7;
  color: #475569 !important;
}

.tender-bid-status--rejected {
  background: #fee2e2;
  color: #b91c1c !important;
}

.tender-bid-status--accepted {
  background: #dcfce7;
  color: #15803d !important;
}

.fix-width-td {
  display: block;
  max-width: 200px !important;
  overflow: hidden;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  word-break: break-word;
}

@media (max-width: 900px) {
  .tender-bid-response-meta {
    grid-template-columns: 1fr;
  }

  .tender-bid-response-meta__item--timer {
    grid-column: auto;
  }
}
</style>

<style>
.application .v-dialog.tender-bid-response-dialog {
  border-radius: 1rem !important;
  max-inline-size: min(72rem, calc(100vw - 2rem)) !important;
  max-width: min(72rem, calc(100vw - 2rem)) !important;
  overflow: hidden !important;
}

.application .v-dialog.tender-bid-response-dialog .tender-bid-response-card {
  background: #ffffff !important;
  border-radius: 1rem !important;
  box-shadow: none !important;
  overflow: hidden;
}

html.oms-night-mode .application .v-dialog.tender-bid-response-dialog .tender-bid-response-card {
  background: var(--oms-surface) !important;
}

html.oms-night-mode .application .tender-bid-response-header {
  background:
    radial-gradient(circle at 100% 0%, rgba(245, 130, 32, 0.18), transparent 42%),
    linear-gradient(135deg, rgba(245, 130, 32, 0.12) 0%, var(--oms-surface) 55%, var(--oms-bg) 100%);
  border-bottom-color: var(--oms-border);
}

html.oms-night-mode .application .tender-bid-response-title {
  color: var(--oms-ink-strong, #e8e6e0) !important;
}

html.oms-night-mode .application .tender-bid-response-meta__item,
html.oms-night-mode .application .tender-bid-response-table-wrap {
  background: var(--oms-surface-soft, var(--oms-surface));
  border-color: var(--oms-border);
}

html.oms-night-mode .application .tender-bid-response-meta__value,
html.oms-night-mode .application .tender-bid-response-timer {
  color: var(--oms-ink-strong, #e8e6e0);
}
</style>
